import { Component, OnInit } from '@angular/core';
import { SearchService, SEARCH_TYPE_CATEGORIA} from '../../../../services/search-service';
import { Observable } from 'rxjs/Observable';
import { FormControl } from '@angular/forms';
import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';

@Component({
  selector: 'app-categoria-autocomplete',
  templateUrl: './categoria-autocomplete.component.html',
  styleUrls: ['./categoria-autocomplete.component.scss']
})
export class CategoriaAutocompleteComponent implements OnInit {

  // Categorias
  public categorias = [];
  public categoriaStateControl: FormControl;
  public filteredCategorias: Observable<any>;
  public selectedCategorias = [];

  constructor(private searchService: SearchService) {
    // Categorias
    this.categoriaStateControl = new FormControl();
    this.filteredCategorias = this.categoriaStateControl.valueChanges
        .startWith(null)
        .debounceTime(1000)
        .switchMap(value => {
          if (value && value.length > 2){
            return this.searchService.searchAutocomplete(value, SEARCH_TYPE_CATEGORIA);
          } else {
            return Observable.from([]);
          }
        })
        .map( value => {
          return value;
        });
  }

  ngOnInit() {
  }

  selectedCategoria(event: MdOptionSelectionChange, value: any) {
    if (event.source.selected &&
          this.selectedCategorias.filter(v => v.Id === value.Id).length === 0) {
        this.selectedCategorias.push(value);
    }
  }

  removeCategoria(categoria){
    this.selectedCategorias.splice(this.selectedCategorias.findIndex(v => v.Id === categoria.Id), 1);
  }

  displayFn(value){
    return null;
  }

}




// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/categoria-autocomplete/categoria-autocomplete.component.ts